import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ipad 111",
  "use": "icon-ipad 111-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-ipad 111\"><path d=\"M746.666667 149.333333a64 64 0 0 1 64 64v597.333334a64 64 0 0 1-64 64H277.333333a64 64 0 0 1-64-64V213.333333a64 64 0 0 1 64-64h469.333334z m0 64H277.333333v597.333334h469.333334V213.333333zM512 682.666667a42.666667 42.666667 0 1 1 0 85.333333 42.666667 42.666667 0 0 1 0-85.333333z m192-426.666667v405.333333H320V256h384z m-64 64H384v277.333333h256V320z\" p-id=\"11951\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol